angular.module('bmsApp.responses').controller('Response500Ctrl', ['$scope', '$log', '$state', 'LastError', function ($scope, $log, $state, LastError) {

		$scope.response = LastError.getError();
		
	}]);